import { cn } from '../../lib/cn'

/** Mono uppercase micro-label (sidebar sections, form groups, kickers). */
export function SectionLabel({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <span className={cn('font-mono text-[10px] uppercase tracking-label text-ink-faint', className)}>
      {children}
    </span>
  )
}
